import React from 'react'
import { Container, Row, Col , Card } from "react-bootstrap";
import { Eye, Bullseye } from "react-bootstrap-icons";
import "./visionmission.scss";

function VisionMission() {
  return (
    <div className="vision-mission-section">
      <Container className="py-5">
        <Row>

          {/* Vision Card */}
          <Col md={6} className="mb-4">
            <Card className="vm-card text-center">
              <div className="icon-wrapper">
                <Eye size={45} />
              </div>
              <Card.Body>
                <Card.Title>Our Vision</Card.Title>
                <Card.Text>
  To be a globally recognized technology company delivering 
  innovative, secure, and scalable software solutions that 
  drive digital transformation and long-term business success.
</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          {/* Mission Card */}
          <Col md={6}>
            <Card className="vm-card text-center">
              <div className="icon-wrapper">
                <Bullseye size={45} />
              </div>
              <Card.Body>
                <Card.Title>Our Mission</Card.Title>
                <Card.Text>
  To empower organizations with reliable, high-quality software 
  solutions through innovation, technical excellence, and 
  customer-centric services, building lasting partnerships since 2025.
</Card.Text>
              </Card.Body>
            </Card>
          </Col>

        </Row>
      </Container>
    </div>
  )
}

export default VisionMission
